import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const notificationsRef = useRef([]);
  notificationsRef.current = notifications;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  //----------------------------------------------- select / view Notifications table  -------------------------------------------------R
  // Fetch all courses
  const fetchNotification = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}notification`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Successful response, update the courses state
            setNotifications(data.data);
            //  ------For TableViewer ------
            const notificationsData = data.data.map((notification) => ({
              title: notification.title,
              message: notification.msg,
              notification_for: notification.notification_for,
              idNumber: notification.nid,
            }));
            setRowData(notificationsData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching Notification.");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchNotification();
  }, [token]);

  // ------------------------------------------------- Edit / Update Notification ----------------------------------------------------U
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addnotification/${encodedId}`);
  };

  // ---------------------------------------------------- Delete Notification ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Notification. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteAnnouncement(deleteId, i);
      }
    });
  };
  //If confirm then delete Notification
  const handleDeleteAnnouncement = async (deleteId, i) => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}notification/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Notification deleted successfully."
            );

            //  ------For TableViewer ------
            const updatedNotification = [...notificationsRef.current];
            updatedNotification.splice(i, 1);
            setNotifications(updatedNotification);

            const notificationsData = updatedNotification.map(
              (notification) => ({
                title: notification.title,
                message: notification.msg,
                notification_for: notification.notification_for,
                idNumber: notification.nid,
              })
            );
            setRowData(notificationsData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting teacher");
    }
    setLoading(false);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "title", filter: true },
    { field: "message", filter: true },
    { field: "notification_for", filter: true },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Notification" subpath={["View Notifications"]} />

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center  row flex justify-between">
            <h5 className="mb-0 col-sm-3 ">View Notifications</h5>
            <button
              type="button"
              className="btn btn-primary col-sm-2 mr-2 mt-2"
              onClick={() => {
                navigate("/addnotification");
              }}
            >
              Add Notification
            </button>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewNotifications;
